import { render, staticRenderFns } from "./mailTerminationWizard.vue?vue&type=template&id=eda8b522"
import script from "./mailTerminationWizard.vue?vue&type=script&lang=js"
export * from "./mailTerminationWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports